// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();

  // If there's no user, redirect them to the home page
  // In a real app, you might redirect to a login page or show a login modal
  if (!currentUser) {
    alert('You must be logged in to view this page.');
    return <Navigate to="/" />;
  }

  // If there is a user, render the component they were trying to access
  return children;
};

export default PrivateRoute;